(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToDeleteController',MedFrequencyToDeleteController);

    MedFrequencyToDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedFrequencyTo'];

    function MedFrequencyToDeleteController($uibModalInstance, entity, MedFrequencyTo) {
        var vm = this;

        vm.medFrequencyTo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedFrequencyTo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
